import Link from 'next/link';

import { ButtonIcon } from '@/shared/ui/button/button-icon';

export interface ISubsectionLinkProps {
    title?: string;
    url?: string;
}

export function SubsectionLink({ title, url }: ISubsectionLinkProps) {
    return (
        <Link href={url || '#'} className='text-title-sm-400 flex items-center gap-4'>
            {title}
            <ButtonIcon size='menu' className='bg-surface-gray-lightest' />
        </Link>
    );
}
